package com.sddamico.swigmore.ds

import com.varabyte.kobweb.compose.ui.graphics.Color

/**
 * Swigmore Poll — color tokens, from the `Swigmore Poll` Claude Design project (Palette A, "Green").
 * A gridiron-and-program-cover look: turf green fields, cream ticket stock, gold ink.
 *
 * Tokens are CSS color strings so they drop straight into [css] declarations; the few places that
 * need a typed Silk [Color] (the page palette) use [SwColor.fieldColor] / [SwColor.creamColor].
 */
object SwColor {
  // ---- Turf greens (dark surfaces) ----
  const val field900 = "#10281d" // deepest band (prototype bar, phone mock)
  const val field800 = "#163d2b" // inset panel on the field
  const val field700 = "#1d4d36" // app background; ink on cream

  // ---- Cream ticket stock (light surfaces) ----
  const val cream = "#efe5c9" // cards, primary text on green
  const val creamDeep = "#e3d7b5" // table header band
  const val creamLight = "#fff8e6" // text-field fill on cream
  const val paper = "#fbf7ec" // email preview sheet

  // ---- Gold (accent: eyebrows, highlights, primary CTA on green) ----
  const val gold = "#d9a93a"

  // ---- Semantic aliases ----
  const val bg = field700
  const val text = cream
  const val textSecondary = "rgba(239,229,201,.82)"
  const val textBody = "rgba(239,229,201,.85)"
  const val textMuted = "rgba(239,229,201,.6)"
  const val textFaint = "rgba(239,229,201,.3)"
  const val hairline = "rgba(239,229,201,.14)"
  const val hairlineSoft = "rgba(239,229,201,.1)"
  const val borderOnField = "rgba(239,229,201,.2)"
  const val borderStrongOnField = "rgba(239,229,201,.4)"
  const val tintOnField = "rgba(239,229,201,.06)"
  const val tintOnFieldHover = "rgba(239,229,201,.12)"
  const val disabledOnField = "rgba(239,229,201,.15)"

  const val ink = field700 // text on cream
  const val inkSecondary = "rgba(29,77,54,.7)"
  const val inkFaint = "rgba(29,77,54,.45)"
  const val stitch = "rgba(29,77,54,.32)" // dashed inset outline on cream cards
  const val stitchStrong = "rgba(29,77,54,.35)"
  const val borderOnCream = "rgba(29,77,54,.35)"
  const val ruleOnCream = "rgba(29,77,54,.14)"
  const val tintOnCream = "rgba(29,77,54,.1)"
  const val tintOnCreamStrong = "rgba(29,77,54,.15)"

  val fieldColor = Color.rgb(0x1D4D36)
  val creamColor = Color.rgb(0xEFE5C9)
}
